import { render, staticRenderFns } from "./UserProfileSummary.vue?vue&type=template&id=51511732&scoped=true&"
import script from "./UserProfileSummary.vue?vue&type=script&lang=ts&"
export * from "./UserProfileSummary.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileSummary.vue?vue&type=style&index=0&id=51511732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51511732",
  null
  
)

export default component.exports